import { MFANotSetupException, MFARequiredException, ThrottledException, UnauthenticatedException, ValidationException } from '~/types/exceptions'

export default defineNuxtPlugin((app) => {
  // Reload the page on a chunk error, e.g. when a new deployment rolls out
  app.hook('app:chunkError', () => {
    window.location.reload()
  })

  app.hook('app:error', (error) => {
    handler(error)
  })

  app.vueApp.config.errorHandler = (error) => {
    handler(error)
  }
})

function handler(error: any) {
  if (error instanceof UnauthenticatedException) {
    useUserStore().logout()
    return navigateTo('/auth/login')
  }
  if (error instanceof ValidationException) {
    return
  }
  if (error instanceof ThrottledException) {
    // toast.warning(`You're doing that too much. Please try again later.`)
    return
  }

  if (error instanceof MFARequiredException) {
    return navigateTo('/auth/totp/verify')
  }

  if (error instanceof MFANotSetupException) {
    return navigateTo('/auth/totp/setup')
  }

  throw error
}
